/*****
 * Created by Allan on 2021/05/11.
 * Contact 84880528@qq.com.
 * *****/
import Http from '@/services/http/'
import {APP_LIST} from "./applist";
export const TOGGLE_OPEN='TOGGLE_OPEN';
export const PASSWORD_VISIBLE='PASSWORD_VISIBLE';
export const PAYMENT_LIST='PAYMENT_LIST';  //查询还款款渠道
export const PAYOUT_LIST='PAYOUT_LIST';  //查询放款渠道
export default{
    state:{
        open:JSON.parse(localStorage.getItem('open')),
        passwordVisible:false,
        paymentList:JSON.parse(localStorage.getItem('paymentList')) || [],
        payoutList:JSON.parse(localStorage.getItem('payoutList')) || [],
        roleModifyNum:localStorage.getItem('roleModifyNum') || 0,  //修改角色次数
    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        open:state=>state.open,
        roleModifyNum:state=>state.roleModifyNum,
    },
    //state 作为第一个参数
    mutations:{
        setRoleModifyNum(state,data){
            localStorage.setItem('roleModifyNum',data);
            state.roleModifyNum=data;
        },
        [TOGGLE_OPEN](state){
            state.open = !state.open;
        },
        setOpen(state,data){
            localStorage.setItem('open',JSON.stringify(data));
            state.open=data;
        },
        [PASSWORD_VISIBLE](state,data){
            state.passwordVisible=!state.passwordVisible;
        },
        [PAYMENT_LIST](state,data){
            localStorage.setItem('paymentList',JSON.stringify(data));
            state.paymentList=data;
        },
        [PAYOUT_LIST](state,data){
            localStorage.setItem('payoutList',JSON.stringify(data));
            state.payoutList=data;
        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        getRoleModifyNum({commit},data){
            commit('setRoleModifyNum',data);
        },
        [TOGGLE_OPEN] ({ commit },open) {
            commit(TOGGLE_OPEN,open);
        },
        getOpen({ commit },data){
            commit('setOpen',data);
        },
        [PASSWORD_VISIBLE] ({ commit },passwordVisible){
            commit(PASSWORD_VISIBLE,passwordVisible)
        },
        [PAYMENT_LIST]({ commit }, data){
            return Http('/finance/allPayChannel',{method:'post',data:{type:'payment_channel'},reqType:'json'}).then(res=>{
                console.log('查询还款款渠道====>',res)
                commit(PAYMENT_LIST,res.data);
            })
        },
        [PAYOUT_LIST]({ commit }, data){
            return Http('/finance/allPayChannel',{method:'post',data:{type:'payout_channel'},reqType:'json'}).then(res=>{
                console.log('查询放款渠道====>',res)
                commit(PAYOUT_LIST,res.data);
            })
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/global.js